import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HighwaysService } from 'src/app/modules/services/highways/highways.service';
import { LoadingService } from '../../../loading/loading.service';
import { MunicipalitiesService } from 'src/app/modules/services/municipalities/municipalities.service';
import { SegmentsService } from 'src/app/modules/services/segments/segments.service';
import { catchError, debounceTime, distinctUntilChanged, filter, of, switchMap } from 'rxjs';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-more-filter',
  templateUrl: './more-filter.component.html',
  styleUrls: ['./more-filter.component.scss']
})
export class MoreFilterComponent implements OnInit {

  constructor(
    private highWayService: HighwaysService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    private municipioService: MunicipalitiesService,
    private dialogRef: MatDialogRef<MoreFilterComponent>,
    private segmentService: SegmentsService,
  ) { }
  ngOnInit(): void {
    this.searchControlMunicipiosHeader.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => typeof value === 'string' && value?.trim().length > 0), // Verifica se é string antes de trim
      switchMap(value => this.municipioService.getMunicipalities(0, '', '', '', value).pipe(
        catchError(() => of([]))
      ))
    ).subscribe((results: any) => {
      this.filteredOptionsMunicipios = results.content;
    });

    this.searchControlHighwayHeader.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter(value => typeof value === 'string' && value?.trim().length > 0), // Verifica se é string antes de trim
      switchMap(value =>
        this.highWayService.getAll(0, '', '', value).pipe(
          catchError(() => {
            this.filteredOptionsHighway = [{ addNew: true }];
            return of([]);
          })
        )
      )
    ).subscribe((results: any) => {
      this.filteredOptionsHighway = results.content;

      if (!this.filteredOptionsHighway?.length) {
        this.filteredOptionsHighway = [{ addNew: true }];
      }
    });
  }

  searchControlHighwayHeader = new FormControl();
  descriptionHighwayHeader = new FormControl();
  selectedOptionMunicipios: any;
  filteredOptionsMunicipios: any[] = [];
  searchControlMunicipiosHeader = new FormControl();
  selectedOptionHighway: any;
  filteredOptionsHighway: any[] = [];
  filter() {
    const data = {
      nomeRodovia: this.selectedOptionHighway?.name ? this.selectedOptionHighway?.name : '',
      nomeMunicio: this.selectedOptionMunicipios?.description ? this.selectedOptionMunicipios?.description : '',
    }

    this.dialogRef.close(data);
  }
  clear() {
    this.selectedOptionMunicipios = '';
    this.selectedOptionHighway = '';
    this.searchControlMunicipiosHeader.setValue('', { emitEvent: false });
    this.searchControlHighwayHeader.setValue('', { emitEvent: false });
    this.dialogRef.close()

  }
  onOptionSelectedMunicipiosHeader(event: any) {
    this.selectedOptionMunicipios = event.option.value;
    this.searchControlMunicipiosHeader.setValue(this.selectedOptionMunicipios.description, { emitEvent: false });

    this.filteredOptionsMunicipios = [];
  }
  onOptionSelectedHighwayHeader(event: any) {

    this.selectedOptionHighway = event.option.value
    this.searchControlHighwayHeader.setValue(this.selectedOptionHighway.name, { emitEvent: false });

    this.filteredOptionsHighway = [];
  }
}
